const ARABIC_INDIC = "٠١٢٣٤٥٦٧٨٩";
const EXT_ARABIC_INDIC = "۰۱۲۳۴۵۶۷۸۹";

/** Convert Arabic-Indic / Extended Arabic-Indic digits to Western 0-9. */
export function normalizeDigits(value) {
  return String(value ?? "").replace(/[٠-٩۰-۹]/g, (ch) => {
    const i = ARABIC_INDIC.indexOf(ch);
    if (i >= 0) return String(i);
    return String(EXT_ARABIC_INDIC.indexOf(ch));
  });
}

/** Format numbers with Western digits regardless of app language. */
export function formatNumberEn(value, options) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  try {
    return new Intl.NumberFormat("en-US", options).format(n);
  } catch {
    return String(value ?? 0);
  }
}

/** Format dates/times with Western digits regardless of app language. */
export function formatDateTimeEn(date, options) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return new Intl.DateTimeFormat("en-US", options).format(d);
  } catch {
    return "";
  }
}
